var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg21(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17H28L17 7H14L3 17Z",
    fill: "url(#paint0_linear_887_4809)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 17H24V20.3333H23.4C22.0745 20.3333 21 19.1394 21 17.6667V17ZM21 26.6667V26V22.9999H21.6C22.9255 22.9999 24 24.1938 24 25.6666V26V29.3333H23.4C22.0745 29.3333 21 28.1394 21 26.6667Z",
    fill: "#FAB215"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 17H17V20.3333H16.4C15.0745 20.3333 14 19.1394 14 17.6667V17ZM14 26.6667V26V22.9999H14.6C15.9255 22.9999 17 24.1938 17 25.6666V26V29.3333H16.4C15.0745 29.3333 14 28.1394 14 26.6667Z",
    fill: "#FAB215"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 17H9.99999V20.3333H9.39999C8.07451 20.3333 7 19.1394 7 17.6667V17ZM7 26.6667V26L7.00001 22.9999H7.60001C8.92549 22.9999 10 24.1938 10 25.6666L9.99999 26V29.3333H9.39999C8.07451 29.3333 7 28.1394 7 26.6667Z",
    fill: "#FAB215"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7H17V2H14V7Z",
    fill: "url(#paint1_linear_887_4809)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4809",
    x1: 16.6364,
    y1: 12.5556,
    x2: 5.27273,
    y2: 12.5556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_887_4809",
    x1: 15.125,
    y1: 7,
    x2: 18.6035,
    y2: 4.98746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.85
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg21);
export default __webpack_public_path__ + "static/media/21.5734de03246ec82d325e1fc00abf933c.svg";
export { ForwardRef as ReactComponent };